import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Instagram, Facebook } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';

const LOGO_URL = '/biolosophy-logo.png';

export default function Footer() {
  const { t } = useLang();

  const columns = [
    {
      title: { it: 'Shop', en: 'Shop' },
      links: [
        { to: '/shop?category=donna', label: { it: 'Donna', en: 'Women' } },
        { to: '/shop?category=uomo', label: { it: 'Uomo', en: 'Men' } },
        { to: '/shop?category=bambino', label: { it: 'Bambino', en: 'Kids' } },
        { to: '/shop', label: { it: 'Tutti i Prodotti', en: 'All Products' } },
      ],
    },
    {
      title: { it: 'Informazioni', en: 'Information' },
      links: [
        { to: '/club', label: { it: 'Club Biolosophy', en: 'Club Biolosophy' } },
        { to: '/filosofia', label: { it: 'La Nostra Filosofia', en: 'Our Philosophy' } },
        { to: '/pre-loved', label: { it: 'Pre-Loved', en: 'Pre-Loved' } },
        { to: '/contatti', label: { it: 'Contatti', en: 'Contact' } },
      ],
    },
    {
      title: { it: 'Assistenza', en: 'Customer Care' },
      links: [
        { to: '/faq', label: { it: 'FAQ', en: 'FAQ' } },
        { to: '/spedizioni-resi', label: { it: 'Spedizioni e Resi', en: 'Shipping & Returns' } },
        { to: '/guida-taglie', label: { it: 'Guida alle Taglie', en: 'Size Guide' } },
        { to: '/termini', label: { it: 'Termini e Condizioni', en: 'Terms & Conditions' } },
        { to: '/privacy', label: { it: 'Privacy Policy', en: 'Privacy Policy' } },
        { to: '/cookie-policy', label: { it: 'Cookie Policy', en: 'Cookie Policy' } },
      ],
    },
  ];

  return (
    <footer className="bg-[#1C1917] text-white">
      <div className="px-6 md:px-12 lg:px-24 py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            {/* Brand */}
            <div className="md:col-span-1">
              <img
                src={LOGO_URL}
                alt="biolosophy"
                className="h-12 mb-4 invert"
              />
              <p className="text-white/60 text-sm leading-relaxed mb-4">
                {t({
                  it: 'Moda sostenibile Made in Italy. Tessuti biologici, economia circolare.',
                  en: 'Sustainable fashion Made in Italy. Organic fabrics, circular economy.',
                })}
              </p>
              <div className="flex items-center gap-2 text-[#4A5D23]">
                <Leaf className="w-4 h-4" />
                <span className="text-sm">{t({ it: '100% Biologico', en: '100% Organic' })}</span>
              </div>
            </div>

            {columns.map((col) => (
              <div key={col.title.it}>
                <h4 className="font-medium mb-4">{t(col.title)}</h4>
                <ul className="space-y-2 text-sm text-white/60">
                  {col.links.map((link) => (
                    <li key={link.to + link.label.it}>
                      <Link to={link.to} className="hover:text-white transition-colors">
                        {t(link.label)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Bottom */}
          <div className="pt-8 border-t border-white/10 flex flex-wrap justify-between items-center gap-4">
            <p className="text-sm text-white/40">
              © {new Date().getFullYear()} biolosophy®. {t({ it: 'Tutti i diritti riservati.', en: 'All rights reserved.' })} — P.IVA IT08028200965
            </p>
            <button
              onClick={() => window.dispatchEvent(new Event('open-cookie-preferences'))}
              data-testid="footer-cookie-preferences-btn"
              className="text-sm text-white/40 hover:text-white transition-colors underline"
            >
              {t({ it: 'Preferenze Cookie', en: 'Cookie Preferences' })}
            </button>
            <div className="flex items-center gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/40 hover:text-white transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/40 hover:text-white transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
